import React, { memo } from 'react';
import FilterIcon from './common/FilterIcon';

const Filters = memo(({onCloseFilters}) => {
	return (
		<div>
			<div className="flex items-center mx-2 w-1/6">
				<button onClick={onCloseFilters}>
					<FilterIcon className="w-6 h-6" />
				</button>
				<h2 className="ml-4 font-bold text-lg">Filters</h2>
			</div>
			<div className="mx-12 my-2">
			<div className="my-4">
				<h1 className="">Time</h1>
				<div>
					<button>dasds</button>
				</div>
			</div>
				<div className="my-4">
				<h1>Location</h1>
				<div>
					<button>dasds</button>
				</div>
			</div>
				<div className="my-4">
				<h1>Activity</h1>
				<div>
					<button>dasds</button>
				</div>
			</div>
			</div>
		</div>
	);
});
export default Filters;
